import { App } from 'vue';
import delegateHtmlLinksDirective from '@/core/dom/delegateHtmlLinks.directive';
import autofocusDirective from '@/core/dom/autofocus.directive';
import fontContentSyncDirective from '@/core/dom/font-content-sync.directive';

export default function initDom(app: App) {
    delegateHtmlLinksDirective(app);
    autofocusDirective(app);
    fontContentSyncDirective(app);
}
